
import {
  defineComponent,
  reactive,
  ref,
  toRaw,
  toRefs,
} from "vue"
import type {UnwrapRef} from "vue"
import ApiLogistics from "@/request/apis/api_logistics"
import {message} from "ant-design-vue/es"
import UploadComponent from "@/components/UploadComponent.vue"
import {ICarTypeUpdateItem} from "@/models/logistics_model";

interface IState {
  loading: boolean
  editItem?: ICarTypeUpdateItem
}

export default defineComponent({
  props: ["editItem", "reset"],
  name: "CarTypeSet",
  components: {UploadComponent},
  setup(props) {
    const state: IState = reactive({
      loading: false,
      list: [],
    })

    const formRef = ref()
    const formState: UnwrapRef<ICarTypeUpdateItem> = reactive({...props.editItem})

    const rules = {
      name: [
        {
          required: true,
          message: "请输入分类名称",
          trigger: ["change", "blur"],
        },
      ],
      phone: [
        {
          required: true,
          message: "请输入电话",
          trigger: ["change", "blur"],
        },
      ],
      head_img: [{required: true, message: '请上传头像', trigger: ['change', 'blur']}],
    }

    const onSubmit = () => {
      formRef.value
          .validate()
          .then(() => {
            if(formState.id){
              onEdit()
            }else{
              onAdd()
            }
          })
          .catch((error: any) => {
            console.log("error", error)
          })
    }
    const resetForm = () => {
      formRef.value.resetFields()
    }
    // 编辑
    const onAdd = async () => {
      state.loading = true
      const res = await ApiLogistics.addCarType({
        ...toRaw(formState),
      })
      state.loading = false
      if (res) {
        message.destroy()
        if (res.error_code === 0) {
          message.success("新增成功")
          if (props.reset) {
            props.reset()
          }
          return
        }
        message.error(res.msg)
      }
    }

    // 编辑
    const onEdit = async () => {
      state.loading = true
      const res = await ApiLogistics.editCarType({
        ...toRaw(formState),
      })
      state.loading = false
      if (res) {
        message.destroy()
        if (res.error_code === 0) {
          message.success("编辑成功")
          if (props.reset) {
            props.reset()
          }
          return
        }
        message.error(res.msg)
      }
    }

    const onImageChange = (url: string) => {
      formState.image = url
    }

    return {
      ...toRefs(state),
      formRef,
      labelCol: {span: 6},
      wrapperCol: {span: 18},
      other: "",
      formState,
      rules,
      onSubmit,
      resetForm,
      onEdit,
      onImageChange,
    }
  },
})
